var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeseries-chart"},[_c('svg')])
}
var staticRenderFns = []

export { render, staticRenderFns }